module.exports = __webpack_public_path__ + "img/news-background-3.a0a5621.jpg";